module.exports = __webpack_public_path__ + "img/pt6-dub.89dff149.jpg";